import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { WindowRefService } from 'i2g-ng-utils';
import shave from 'shave';

@Directive({
  selector: '[i2gMultiLineTruncate]',
})
export class MultiLineTruncateDirective implements AfterViewInit {
  @Input('multiLineTruncate') lines: number;

  private _el: any;
  private _window: any;

  constructor(elementRef: ElementRef, windowRefService: WindowRefService) {
    this._el = elementRef.nativeElement;
    this._window = windowRefService.nativeWindow;
  }

  ngAfterViewInit() {
    if (this.lines > 1) {
      setTimeout(this.truncateText.bind(this));
    }
  }

  truncateText() {
    const computedStyles = this._window.getComputedStyle(this._el);
    const lineHeight = parseInt(
      computedStyles.getPropertyValue('line-height'),
      10
    );
    const maxHeight = lineHeight * (+this.lines + 0.5);

    if (maxHeight) {
      shave(this._el, maxHeight, { spaces: false });
    }
  }
}
